import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import { isAuthenticated, isGuest } from "./auth";
import ErrorBoundary from "./helpers/ErrorBoundary";

const Home = React.lazy(() => import("./containers/Home"));
const SearchContainer = React.lazy(() =>
  import("./containers/SearchContainer")
);

const FaqContainer = React.lazy(() => import("./containers/FaqContainer"));
const PrivacyPolicyContainer = React.lazy(() =>
  import("./containers/PrivacyPolicyContainer")
);
// const ReturnPolicyContainer = React.lazy(() =>
//   import("./containers/ReturnPolicyContainer")
// );
const TermConditionsContainer = React.lazy(() =>
  import("./containers/TermConditionsContainer")
);

const DynamicServiceFormContainer = React.lazy(() =>
  import("./containers/DynamicServiceForm")
);
const EditServiceForm = React.lazy(() =>import("./containers/EditServiceForm"));

const Login = React.lazy(() => import("./containers/Login"));
const Logout = React.lazy(() => import("./containers/Logout"));
const ForgotPassword = React.lazy(() => import("./containers/ForgotPassword"));
const Register = React.lazy(() => import("./containers/Register"));
const VerifyOTP = React.lazy(() => import("./containers/VerifyOTP"));
const ResetPasswordVerifyOTP = React.lazy(() =>import("./containers/ResetPasswordVerifyOTP"));
const ChangePassword = React.lazy(() => import("./containers/ChangePassword"));
const TicketsPage = React.lazy(() => import("./containers/TicketsPage"));
const TicketDetailPage = React.lazy(() => import("./containers/TicketDetailPage"));
const NewTicketPage = React.lazy(() => import("./containers/NewTicketPage"));
const RedirectWithToken = React.lazy(() => import("./containers/RedirectWithToken"));
const ThankYou = React.lazy(() => import("./containers/ThankYou"));

const MyProfile = React.lazy(() => import("./containers/MyProfile"));
const MyServices = React.lazy(() => import("./containers/MyServices"));
const MyInvoices = React.lazy(() => import("./containers/MyInvoices"));
const ViewInvoice = React.lazy(() => import("./containers/ViewInvoice"));
const PaymentResult = React.lazy(() => import("./containers/PaymentResult"));
const SiteLayout = React.lazy(() => import("./layouts/SiteLayout"));
const PublicLayout = React.lazy(() => import("./layouts/PublicLayout"));
const PlainLayout = React.lazy(() => import("./layouts/PlainLayout"));




const routeList = [ 
  {
    path: "/login",
    element: <Login/>,
    layout: PlainLayout,
    exact: true,
    private: false,
  },
  {
    path: "/",
    element: <Home/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
    {
    path: "/services/:serviceId/:serviceSulg",
    element: <DynamicServiceFormContainer/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
    {
    path: "/view-submitted/:orderId",
    element: <EditServiceForm/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
 
  {
    path: "/tickets",
    element: <TicketsPage/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/my-services",
    element: <MyServices/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/my-invoices",
    element: <MyInvoices/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/view-invoice/:id",
    element: <ViewInvoice/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/payment-result/:tranRef",
    element: <PaymentResult/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  
  {
    path: "/tickets/new",
    element: <NewTicketPage/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/view-ticket/:id",
    element: <TicketDetailPage/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/register",
    element: <Register/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/logout",
    element: <Logout/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/otp-verification/:token",
    element: <VerifyOTP/>,
    layout: PlainLayout,
    private: false,
  },
   {
    path: "/forgot-password",
    element: <ForgotPassword/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/my-profile",
    element: <MyProfile/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
    {
    path: "/change-password",
    element: <ChangePassword/>,
    layout: SiteLayout,
    private: false,
  },
    {
    path: "/faq",
    element: <FaqContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/terms-conditions",
    element: <TermConditionsContainer/>,
    layout: SiteLayout,
    private: false,
  },
   {
    path: "/reset-password/:token",
    element: <ResetPasswordVerifyOTP/>,
    layout: PlainLayout,
    private: false,
  },
   {
    path: "/q/:serviceSulg/:token",
    element: <RedirectWithToken/>,
    layout: PublicLayout,
    private: false,
  },
     {
    path: "/order-confirmation",
    element: <ThankYou/>,
    layout: PublicLayout,
    private: false,
  },
  
  
];



const RouteWithSubRoutes = (route, index) => (
  <Route
    key={index}
    path={route.path}
    element={<route.layout>{route.element}</route.layout>}
  />
);
const RouteWithPrivateRoutes = (route, index) => {
  if (isAuthenticated() && !isGuest()) {
    return (
      <Route
        key={index}
        path={route.path}
        element={<route.layout>{route.element}</route.layout>}
      />
    );
  }
  return <Route key={index} path={route.path} element={<Navigate to="/" />} />;
};

export const RoutesPage = () => {
  const loader = (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span className="spinner-border" />
    </div>
  );

  return (
    <Router>
        {/* <ErrorBoundary> */}
      <Suspense fallback={loader}>
        <Routes>
          {routeList.map((route, index) => (
            route.private
            ? RouteWithPrivateRoutes(route, index)
            :
            RouteWithSubRoutes(route, index)
          ))}
        </Routes>
      </Suspense>
      {/* </ErrorBoundary> */}
    </Router>
  );
};